import { ArrowRight, LockKeyhole, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Volume } from '../types/hub';

interface Props {
  volume: Volume;
  owned: boolean;
  compact?: boolean;
}

export function VolumeCard({ volume, owned, compact = false }: Props) {
  const style = { '--volume-accent': volume.accent_color || '#0F4C81' } as React.CSSProperties;
  const publicSite = import.meta.env.VITE_PUBLIC_SITE_URL || 'https://therebuildprocess.com';
  const salesHref = volume.sales_path ? `${publicSite}${volume.sales_path}` : null;

  return (
    <article className={`volume-card ${owned ? 'owned' : 'locked'} ${compact ? 'compact' : ''}`} style={style}>
      <div className="volume-card-top">
        <span className="volume-number">{volume.roman_numeral}</span>
        <span className={`status-chip ${owned ? 'status-owned' : 'status-locked'}`}>
          {owned ? <CheckCircle2 size={13} /> : <LockKeyhole size={13} />}
          {owned ? 'Unlocked' : 'Locked'}
        </span>
      </div>
      <p className="eyebrow">Volume {volume.roman_numeral}</p>
      <h3>{volume.short_title}</h3>
      <p className="volume-subtitle">{volume.subtitle}</p>
      <p className="volume-description">{volume.description}</p>
      <div className="volume-card-actions">
        {owned ? (
          <Link className="button primary" to={`/hub/rebuilds/${volume.slug}`}>
            Open rebuild <ArrowRight size={16} />
          </Link>
        ) : salesHref ? (
          <a className="button secondary" href={salesHref}>
            Explore this rebuild <ArrowRight size={16} />
          </a>
        ) : (
          <button className="button secondary" disabled>Coming soon</button>
        )}
      </div>
    </article>
  );
}
